export default theme => ({
  root: {
    textAlign: "center",
    verticalAlign: "middle",
  },
  toolbar: {
    display: "inline-block",
    verticalAlign: "middle",
    marginTop: 5,
  },
  toolbar_mobile: {
    float: "left",
    marginLeft: 25,
  },
  caption: {
    display: "inline-block",
    verticalAlign: "middle",
  },
  actions: {
    display: "inline-block",
    verticalAlign: "middle",
  },
});
